import apiClient from './apiClient';

export interface Notification {
  id: number;
  type: string;
  title: string;
  message?: string | null;
  evaluation_id?: number | null;
  is_read: boolean;
  created_at?: string | null;
}

const notificationsApi = {
  list: () =>
    apiClient.get<Notification[]>('/notifications').then(r => r.data),

  unreadCount: () =>
    apiClient.get<{ count: number }>('/notifications/unread-count').then(r => r.data.count),

  markRead: (id: number) =>
    apiClient.put<Notification>(`/notifications/${id}/read`).then(r => r.data),

  markAllRead: () =>
    apiClient.put('/notifications/read-all').then(r => r.data),
};

export default notificationsApi;
